"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/application-info.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Fapplication-info.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationInfo = void 0;
const application_1 = require("./application");
const evaluation_results_1 = require("./evaluation-results");
const product_1 = require("./product");
const protobufPackage = 'com.step.underwriting.common.proto';
function createBaseApplicationInfo() {
    return {
        id: '',
        status: application_1.ApplicationStatus.INVALID_APPLICATION_STATUS,
        statusReason: application_1.StatusReason.INVALID_STATUS_REASON,
        employmentStatus: application_1.EmploymentStatus.INVALID_EMPLOYMENT_STATUS,
        annualIncome: undefined,
        info: undefined,
        products: [],
        fromBatch: false,
        evaluationResults: undefined,
        createdAtMs: '0',
        updatedAtMs: '0',
        retryAfterMs: '0',
        closedAtMs: '0',
    };
}
exports.ApplicationInfo = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            status: isSet(object.status)
                ? (0, application_1.applicationStatusFromJSON)(object.status)
                : application_1.ApplicationStatus.INVALID_APPLICATION_STATUS,
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.statusReason)) {
            message.statusReason = (0, application_1.statusReasonFromJSON)(object.statusReason);
        }
        if (isSet(object.employmentStatus)) {
            message.employmentStatus = (0, application_1.employmentStatusFromJSON)(object.employmentStatus);
        }
        if (isSet(object.annualIncome)) {
            message.annualIncome = application_1.AnnualIncome.fromJSON(object.annualIncome);
        }
        if (isSet(object.info)) {
            message.info = application_1.BorrowerInfo.fromJSON(object.info);
        }
        if (globalThis.Array.isArray(object?.products)) {
            message.products = object.products.map((e) => product_1.Product.fromJSON(e));
        }
        if (isSet(object.fromBatch)) {
            message.fromBatch = globalThis.Boolean(object.fromBatch);
        }
        if (isSet(object.evaluationResults)) {
            message.evaluationResults = evaluation_results_1.EvaluationResults.fromJSON(object.evaluationResults);
        }
        if (isSet(object.retryAfterMs)) {
            message.retryAfterMs = globalThis.String(object.retryAfterMs);
        }
        if (isSet(object.closedAtMs)) {
            message.closedAtMs = globalThis.String(object.closedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.status !== application_1.ApplicationStatus.INVALID_APPLICATION_STATUS) {
            obj.status = (0, application_1.applicationStatusToJSON)(message.status);
        }
        if (message.statusReason !== undefined &&
            message.statusReason !== application_1.StatusReason.INVALID_STATUS_REASON) {
            obj.statusReason = (0, application_1.statusReasonToJSON)(message.statusReason);
        }
        if (message.employmentStatus !== undefined &&
            message.employmentStatus !== application_1.EmploymentStatus.INVALID_EMPLOYMENT_STATUS) {
            obj.employmentStatus = (0, application_1.employmentStatusToJSON)(message.employmentStatus);
        }
        if (message.annualIncome !== undefined) {
            obj.annualIncome = application_1.AnnualIncome.toJSON(message.annualIncome);
        }
        if (message.info !== undefined) {
            obj.info = application_1.BorrowerInfo.toJSON(message.info);
        }
        if (message.products?.length) {
            obj.products = message.products.map((e) => product_1.Product.toJSON(e));
        }
        if (message.fromBatch !== undefined && message.fromBatch !== false) {
            obj.fromBatch = message.fromBatch;
        }
        if (message.evaluationResults !== undefined) {
            obj.evaluationResults = evaluation_results_1.EvaluationResults.toJSON(message.evaluationResults);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.retryAfterMs !== undefined && message.retryAfterMs !== '0') {
            obj.retryAfterMs = message.retryAfterMs;
        }
        if (message.closedAtMs !== undefined && message.closedAtMs !== '0') {
            obj.closedAtMs = message.closedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.ApplicationInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApplicationInfo();
        message.id = object.id ?? '';
        message.status = object.status ?? application_1.ApplicationStatus.INVALID_APPLICATION_STATUS;
        message.statusReason = object.statusReason ?? application_1.StatusReason.INVALID_STATUS_REASON;
        message.employmentStatus = object.employmentStatus ??
            application_1.EmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        message.annualIncome = (object.annualIncome !== undefined && object.annualIncome !== null)
            ? application_1.AnnualIncome.fromPartial(object.annualIncome)
            : undefined;
        message.info = (object.info !== undefined && object.info !== null)
            ? application_1.BorrowerInfo.fromPartial(object.info)
            : undefined;
        message.products = object.products?.map((e) => product_1.Product.fromPartial(e)) || [];
        message.fromBatch = object.fromBatch ?? false;
        message.evaluationResults =
            (object.evaluationResults !== undefined && object.evaluationResults !== null)
                ? evaluation_results_1.EvaluationResults.fromPartial(object.evaluationResults)
                : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.retryAfterMs = object.retryAfterMs ?? '0';
        message.closedAtMs = object.closedAtMs ?? '0';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=application-info.js.map